import template from './user_profile.html';
import controller from './user_profile.controller';

let userprofileComponent = {
  restrict: 'E',
  template,
  controller
};

export default userprofileComponent;


// WEBPACK FOOTER //
// ./client/app/components/user_profile/user_profile.component.js